// Estatus de `creditApp.status` que indican que la solicitud fue rechazada
// (por mesa de control, comité o admin) — usado tanto para el chequeo de
// estatus terminal como para decidir, en "Detalle de arrendamiento", que
// solo debe mostrarse la tab "Datos generales".
export const REJECTED_CREDIT_APPLICATION_STATUSES = [
  'rejected_by_mesa_control',
  'rejected_by_committee',
  'rejected_by_admin',
] as const

// Estatus de `creditApp.status` (respuesta de GET /credit-application) que
// indican que la solicitud ya fue resuelta (por mesa de control, comité o
// admin) y por lo tanto el usuario queda liberado para seleccionar una nueva
// cotización y volver a dar clic en "Continuar".
export const TERMINAL_CREDIT_APPLICATION_STATUSES = [
  ...REJECTED_CREDIT_APPLICATION_STATUSES,
  'approved_by_committee',
  'approved_by_admin',
] as const

export type TerminalCreditApplicationStatus =
  (typeof TERMINAL_CREDIT_APPLICATION_STATUSES)[number]

/**
 * Indica si una solicitud de crédito ya terminó su ciclo (aprobada o
 * rechazada, sin importar la instancia que decidió) y por lo tanto ya no
 * debe bloquear al usuario para iniciar una nueva solicitud.
 */
export const isCreditApplicationTerminal = (
  status?: string | null
): boolean =>
  !!status &&
  (TERMINAL_CREDIT_APPLICATION_STATUSES as readonly string[]).includes(
    status
  )

/**
 * Indica si una solicitud de crédito fue rechazada — usado en "Detalle de
 * arrendamiento" para mostrar únicamente la tab "Datos generales".
 */
export const isRejectedCreditApplicationStatus = (
  status?: string | null
): boolean =>
  !!status &&
  (REJECTED_CREDIT_APPLICATION_STATUSES as readonly string[]).includes(status)
